import {Component, signal, ChangeDetectionStrategy} from '@angular/core';

import {MatButtonToggle, MatButtonToggleGroup} from '@angular/material/button-toggle';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {FormsModule} from '@angular/forms';
import {MonthlyBalanceComponent} from './month/monthly-balance.component';
import {DailyBalanceComponent} from './day/daily-balance.component';
import {DayDatepickerComponent} from '../datepicker/day-datepicker.component';
import {MonthDatepickerComponent} from '../datepicker/month-datepicker.component';
import {YearDatepickerComponent} from '../datepicker/year-datepicker.component';
import {YearBalanceComponent} from './year/year-balance.component';
import { TotalBalanceComponent } from './total/total-balance.component';
import { RouterLink } from '@angular/router';

export type Interval = 'day' | 'week' | 'month' | 'year' | 'total';

@Component({
  selector: 'app-energy-balance',
  imports: [
    MatButtonToggleGroup,
    MatButtonToggle,
    MatDatepickerModule,
    FormsModule,
    MatFormFieldModule,
    MonthlyBalanceComponent,
    DailyBalanceComponent,
    DayDatepickerComponent,
    MonthDatepickerComponent,
    YearDatepickerComponent,
    YearBalanceComponent,
    TotalBalanceComponent,
    RouterLink
],
  providers: [],
  templateUrl: './energy-balance.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './energy-balance.component.css',
})
export class EnergyBalanceComponent {
  selectedInterval = signal<Interval>('month');
  selectedDate = signal<Date>(new Date());

  onIntervalSelectionChange(event: any) {
    console.log('Interval changing to:', event.value);
    this.selectedInterval.set(event.value);

    // Use today's date as the base date
    const today = new Date();
    let newDate: Date;

    switch (event.value) {
      case 'month':
        // Set to first day of current month
        newDate = new Date(today.getFullYear(), today.getMonth(), 1);
        break;
      case 'year':
        // Set to first day of current year
        newDate = new Date(today.getFullYear(), 0, 1);
        break;
      case 'total':
        // Set to first day of current year
        newDate = new Date(today.getFullYear(), 0, 1);
        break;
      default:
        // For day view, use today's date
        newDate = today;
    }

    this.updateDate(newDate);
  }

  updateDate(date: Date) {
    this.selectedDate.set(date);
  }

  constructor() {}
}
